import PuxButton from "../../../../PuxButton/PuxButton.vue";
import PuxTranslate from "../../../../PuxTranslate/PuxTranslate.vue";

import UiValidatedJsonModeManyMixin from "../../UiValidatedJsonModeManyMixin";

// @vue/component
export default {
  name: "ModeListReadOnly",
  components: {
    PuxButton,
    PuxTranslate,
  },
  mixins: [
    UiValidatedJsonModeManyMixin
  ],
  props: {
    model: {
      type: Array,
      required: true,
    },
  },
};
